export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_395.aac48333.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};